/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import api from '../../services/api';

const ConfirmPickup = ({
  pickup_information, location_id, company_uuid, type,
}) => {
  const [confirmed, setConfirmed] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const onClick = () => {
    setDisabled(true);

    api.pickup.confirm({
      company_uuid,
      location_id,
      type,
    }).then(() => setConfirmed(true));
  };

  return (
    <div className="d-flex flex-column justify-content-center align-items-center">
      <div>
        <p>
          Company name:
          { pickup_information.company_name ?? ''}
        </p>
        <p>
          Phone:
          { pickup_information.phone ?? ''}
        </p>
        <p>
          Address:
          { `${ pickup_information.street_address1 ?? ''} ${ pickup_information.street_address2 ?? ''}` }
        </p>
        <p>
          City/state/zip:
          { `${ pickup_information.city ?? '' } ${ pickup_information.state ?? '' } ${ pickup_information.zip ?? '' }` }
        </p>
      </div>
      {
        (
          (confirmed && <p>Confirmed</p>)
        || (
          <button
            disabled={disabled}
            style={{ cursor: disabled || 'pointer' }}
            onClick={onClick}
          >
            Confirm
          </button>
        )
        )
      }
    </div>
  );
};

ConfirmPickup.propTypes = {
  pickup_information: PropTypes.instanceOf(Object).isRequired,
  location_id: PropTypes.string.isRequired,
  company_uuid: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default ConfirmPickup;
